import { headers } from "@utils/utils";

export const usePreguntaStore = defineStore("pregunta", () => {
  // estado
  const pregunta = ref({
    id: null,
    pregunta: null,
    descripcion: null,
    tipo_respuesta: 1,
    opcion_respuesta: [{ option: "", valor: 0 }],
    opcional: false,
    responder_despues: false,
  });

  const preguntas = ref([]);

  // getters

  const draft = computed(() => clone(pregunta.value));

  const tipoPreguntasOptions = computed(() => [
    {
      label: "Respuesta larga",
      value: 2,
      icon: "fa-bars",
      disabled: false,
    },

    {
      label: "Respuesta corta",
      value: 1,
      icon: "fa-minus",
      disabled: false,
    },

    {
      label: "Varias opciones",
      value: 3,
      icon: "fa-square-check",
      disabled: false,
    },
    {
      label: "Desplegable",
      value: 4,
      icon: "fa-rectangle-list",
      disabled: false,
    },
    { label: "Fecha", value: 5, icon: "fa-calendar-days", disabled: true },
    { label: "Hora", value: 6, icon: "fa-clock", disabled: true },
    { label: "Casillas", value: 7, icon: "fa-list-ul", disabled: false },
  ]);

  // methods

  const clear = () => {
    pregunta.value = {
      id: null,
      pregunta: null,
      descripcion: null,
      tipo_respuesta: 1,
      opcion_respuesta: [{ option: "", valor: 0 }],
      opcional: false,
      responder_despues: false,
    };
  };

  const fetch = (pregunta_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/preguntas/${pregunta_id}/fetch-data`)
        .then(({ data }) => {
          if (data.id) {
            pregunta.value = data;
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/preguntas/fetch-data`, params)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/preguntas/${datos.id}`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/preguntas`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (pregunta_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/preguntas/${pregunta_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const agregarOption = () => {
    let opcion = {
      option: "",
      valor: 0,
    };

    pregunta.value.opcion_respuesta = [
      ...pregunta.value.opcion_respuesta,
      opcion,
    ];
  };

  const quitarOpciones = () => {
    pregunta.value.opcion_respuesta = [{ option: "", valor: 0 }];
  };

  const fetchListSelect = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/preguntas/list-select`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const importarPreguntas = ({ archivo }) => {
    let formData = new FormData();
    formData.append("archivo", archivo);

    return new Promise((resolve, reject) => {
      axios
        .post(`/api/preguntas/importar`, formData, headers)
        .then((resource) => {
          resolve(resource);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    pregunta,
    preguntas,
    draft,
    tipoPreguntasOptions,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    quitarOpciones,
    agregarOption,
    fetchListSelect,
    importarPreguntas,
  };
});

export default usePreguntaStore;
